import logoSvg from "../logo.svg";

export function Navbar() {
  return (
    <nav className="relative z-20 flex w-full items-center py-5 gap-2.5">
      <img src={logoSvg} alt="passkeep.ai" style={{ width: "26px", height: "26px" }} />
      <span
        className="font-semibold tracking-tight text-white"
        style={{ fontSize: "20px" }}
      >
        passkeep.ai
      </span>
    </nav>
  );
}
